module.exports = __webpack_public_path__ + "img/Sustainable4.4ec2b3a1.jpg";